import React, { useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import createPersistedState from "use-persisted-state";
import { getTranslatedClinicNameFromId } from "../../utils";

function WaitListItem({ patientWaitList }) {
  const { t } = useTranslation();

  return (
    <div className="box_view_app">
      <div className="head_view d-flex justify-content-between align-items-center">
        <span className="txt_normal">
          {t(
            `onboard.CHOOSE_DOC.options.${patientWaitList?.ownerMetadata?.code}`
          )}
        </span>
        <span className="txt_small">{t("appointment.DOCTOR.doctor1")}</span>
      </div>
      <span className="txt_normal">
        {moment(new Date(patientWaitList?.date)).format("DD MMMM, dddd, YYYY")}
      </span>
      <span className="txt_normal">
        {getTranslatedClinicNameFromId(patientWaitList?.spaceMetadata?.code, t)}
      </span>
      <div className="blueText">{t("appointment.BUTTON.waitListed")}</div>
    </div>
  );
}

export default WaitListItem;
